import { apiSlice } from "../../../api/ApiService";

const createMilestoneTaskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMilestoneTask: builder.mutation({
      query: ({ body, accessToken }) => ({
        url: `/api/v1/Administration/milestone`,
        method: "POST",
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        data: body,
      }),
      invalidatesTags: [{ type: 'MilestoneTask' }],
    }),
  }),
  overrideExisting: false,
});

export const { useCreateMilestoneTaskMutation } = createMilestoneTaskApi;
export default createMilestoneTaskApi;
